export default "__VITE_ASSET__BV60$v7p__"